if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form) {
          this.formName = this.form.querySelector('[name=id]')
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          if (this.submitButton) {
            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }

          this.hideErrors = this.dataset.hideErrors === 'true';
        }
      }
      onSubmitHandler(evt) {
        // bundle builder logic

        let addedFromBundleBuilder = false;

        if (evt.target.closest('.bundle-builder__add-to-bundle')) {
          addedFromBundleBuilder = true;

          //disable all other buttons
          document.querySelectorAll('.bundle-builder__collections.show .quick-add__submit').forEach(el => {
            el.classList.add('disabled_btn')
          })
        }

        // END bundle builder logic

        evt.preventDefault();
        if (!this.submitButton) return; //exit function if we don't have a submit button
        if (this.submitButton.classList.contains('js-back-in-stock')) return; //exit function if the button has on it 'js-back-in-stock'
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);

        if (this.cart) {
          const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
          if (window.location.href.includes('/cart') && !sectionIds.includes('main-cart-items')) {
            sectionIds.push('main-cart-items');
          }

          formData.append(
            'sections',
            sectionIds
          );
          formData.append('sections_url', window.location.pathname);
          formData.append('quantity', 1);


          // for a/b test 3 min spent offer
          if (document.body.classList.contains('ab-test__3min-offer')) {
            formData.append('properties[_threeMinSpent]', 'true');
          }
          else {
            formData.append('properties[_threeMinSpent]', 'false');
          }
          // END for a/b test 3 min spent offer
        }

        if (window.hiddenSaleActive) {
          formData.append('attributes[dsrDiscounts]', 'true');
        }
        else {
          formData.append('attributes[dsrDiscounts]', 'false');
        }

        const fetchCfg = fetchConfigAux('javascript', { body: formData });

        fetch(`${routes.cart_add_url}.js`, {
          ...fetchCfg,
          headers: {
            ...fetchCfg.headers,
            Accept: 'text/html',
          },
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (addedFromBundleBuilder) {

                let oldText = evt.submitter.dataset.btnText
                evt.submitter.querySelector('span').innerHTML = `AÑADIDO`
                evt.submitter.classList.add('bundle-item-added')

                setTimeout(() => {
                  evt.submitter.querySelector('span').innerHTML = oldText;
                  evt.submitter.classList.remove('bundle-item-added');

                  this.cart.renderContents(response, addedFromBundleBuilder, [this.form.querySelector("[name=product-id]").value]);

                }, 1000)
                // END bundle builder logic
              }
              else {
                this.cart.renderContents(response, false, [this.form.querySelector("[name=product-id]").value]);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            updateAddToCartButtonsText(this.submitButton);

            setTimeout(() => {
              if (addedFromBundleBuilder) {
                //reenable btns
                document.querySelectorAll('.bundle-builder__collections.show .quick-add__submit').forEach(el => {
                  el.classList.remove('disabled_btn')
                })
              }
            }, 1250);

            if (window.innerWidth < 990) {
              // autoOpenFreeProductModal();
              if (evt.submitter.closest('.item-atc')) {
                document.querySelector('#free-product-modal-gift').classList.toggle('show');
              }
            }
            else {
              if (evt.submitter.closest('.item-atc')) {
                document.querySelector('#free-product-modal-gift').classList.remove('show');
              }
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
